import FixedRow from './FixedRow';

export default FixedRow;
